module.exports = __webpack_public_path__ + "static/media/About Us Picture 01.69e83da0.jpg";